import React from 'react';

import { FlightResultRequestOrderCriteriaEnum } from 'models/flightSearch';

import { Container, Option, OptionTitle, OptionDetail } from './styles';

export interface Option {
  key: FlightResultRequestOrderCriteriaEnum;
  title: string;
  price: string | null;
  duration: string | null;
  onClick: () => void;
  testId?: string;
}

interface Props {
  options: Option[];
  current: FlightResultRequestOrderCriteriaEnum;
  hasFilters: boolean;
}

const BestOptions = ({ options, current, hasFilters }: Props) => (
  <Container>
    {options.map((option, index) => (
      <React.Fragment key={option.key}>
        <Option onClick={option.onClick} active={current === option.key} data-testid={option.testId}>
          <OptionTitle active={current === option.key}>{option.title}</OptionTitle>
          {!hasFilters && (
            <>
              <OptionDetail highlight={option.key === FlightResultRequestOrderCriteriaEnum.PRICE}>
                {option.price}
              </OptionDetail>
              <OptionDetail highlight={option.key === FlightResultRequestOrderCriteriaEnum.DURATION}>
                {option.duration}
              </OptionDetail>
            </>
          )}
        </Option>
      </React.Fragment>
    ))}
  </Container>
);

export default BestOptions;
